import { confirmDiscardMassCommChanges, confirmDiscardMassCommChangesNative, markMassCommClean } from '../manager/mass-comm-unsaved-guard.js';

export function wireBackToHistory() {
    $('#back_link').off('click.navButtonsBack').on('click.navButtonsBack', (event) => {
        event.preventDefault();
        confirmDiscardMassCommChangesNative(() => {
            markMassCommClean();
            window.history.back();
        });
    });
}

export function setBack(show) {
    $('#back_link').toggleClass('topbar-hidden', !show);
}

export function clearBack() {
    setBack(false);
}

export function setHome(handler) {
    const $link = $('.topbar-home-link');
    if (typeof handler !== 'function') {
        $link.addClass('topbar-hidden');
        return;
    }
    $link.off('click.navButtonsHome').on('click.navButtonsHome', (event) => {
        event.preventDefault();
        confirmDiscardMassCommChanges(() => {
            markMassCommClean();
            handler();
        });
    }).removeClass('topbar-hidden');
}

export function clearHome() {
    setHome(null);
}
